

import { atom , useRecoilValue, useSetRecoilState, useResetRecoilState} from "recoil";


const appDriverListAtom = atom({key:'appDriverListAtom', default:{user_info:[]
}});





export  const SetAppDriverList = () => useSetRecoilState(appDriverListAtom);
export  const GetAppDriverList = () => useRecoilValue(appDriverListAtom);









